import React from 'react';
import Typography from '@material-ui/core/Typography';
import { Grid } from '@material-ui/core';



export default function AcTotales({ data, positivo, totalPositivos }) {
    return (
        <>
            <Typography align="center" style={{ fontWeight: 'bold', fontSize: "26px" }} color='primary'>
                {totalPositivos}
            </Typography>

            <Grid item>
                <Grid item xs={12} sm container >
                    <Grid item xs container direction="column" >
                        <Grid item xs>
                            <Grid item xs={12} sm container alignItems="center" justifyContent="center" style={{ marginTop: '20%' }} >
                                <Typography component="p" align="center" variant="h3" style={{ color: "#d91c23", fontSize: '60px', fontWeight: 'bold' }} >
                                    {positivo}
                                </Typography>
                            </Grid>
                        </Grid>
                    </Grid>
                </Grid>
            </Grid>


        </>
    );
}